"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @category Guard
 * @returns `true` if value is **strictly** an instance of **`Object`**
 * @example
 * ```typescript
 *   if(isObject(values)) return { ...values, completed:true };
 * ```
 */
const isObject = ((value) => {
    return (value instanceof Object && Object === Object.getPrototypeOf(value).constructor);
});
exports.default = isObject;
